export default __webpack_public_path__ + "static/media/map_ntu.2a0c7dfe.png";